import type { AuthTokens } from 'aws-amplify/auth';

import { USERS_API_URL } from 'constants/ApiConstants';

import type { MetaAction } from 'modules/global/generic.types';

import * as types from './actionTypes';
import type { LOGIN_STEPS } from './constant';
import type * as Actions from './types';

export const signIn = (payload: Actions.SignInPayload, meta: MetaAction = {}): Actions.SignInRequestAction => ({
  type: types.SIGN_IN_REQUEST,
  payload,
  meta,
});

export const signInSuccess = (user: AuthTokens, meta: MetaAction = {}): Actions.SignInSuccessAction => ({
  type: types.SIGN_IN_SUCCESS,
  payload: user,
  meta,
});

export const signInFailure = (error: Error, meta: MetaAction = {}): Actions.SignInFailureAction => ({
  type: types.SIGN_IN_FAILURE,
  payload: error,
  error: true,
  meta,
});

export const verifySignIn = (code: Actions.VerifySignInPayload, meta: MetaAction = {}): Actions.VerifySignInRequestAction => ({
  type: types.VERIFY_SIGN_IN_REQUEST,
  payload: code,
  meta,
});

export const verifySignInSuccess = (meta: MetaAction = {}): Actions.VerifySignInSuccessAction => ({
  type: types.VERIFY_SIGN_IN_SUCCESS,
  meta,
});

export const verifySignInFailure = (error: Error, meta: MetaAction = {}): Actions.VerifySignInFailureAction => ({
  type: types.VERIFY_SIGN_IN_FAILURE,
  payload: error,
  error: true,
  meta,
});

export const resendVerifyCode = (meta: MetaAction = {}): Actions.ResendVerifyCodeRequestAction => ({
  type: types.RESEND_VERIFY_CODE_REQUEST,
  meta,
});

export const resendVerifyCodeSuccess = (meta: MetaAction = {}): Actions.ResendVerifyCodeSuccessAction => ({
  type: types.RESEND_VERIFY_CODE_SUCCESS,
  meta,
});

export const resendVerifyCodeFailure = (meta: MetaAction = {}): Actions.ResendVerifyCodeFailureAction => ({
  type: types.RESEND_VERIFY_CODE_FAILURE,
  payload: undefined,
  error: true,
  meta,
});

export const signOut = (payload: Actions.SignOutPayload, meta: MetaAction = {}): Actions.SignOutRequestAction => ({
  type: types.SIGN_OUT_REQUEST,
  payload,
  meta,
});

export const signOutSuccess = (meta: MetaAction = {}): Actions.SignOutSuccessAction => ({
  type: types.SIGN_OUT_SUCCESS,
  meta,
});

export const signOutFailure = (error: Error, meta: MetaAction = {}): Actions.SignOutFailureAction => ({
  type: types.SIGN_OUT_FAILURE,
  payload: error,
  error: true,
  meta,
});

export const signOutEmergency = (meta: MetaAction = {}): Actions.SignOutEmergencyAction => ({
  type: types.SIGN_OUT_EMERGENCY,
  meta,
});

export const loadSession = (meta: MetaAction = {}): Actions.LoadSessionRequestAction => ({
  type: types.LOAD_SESSION_REQUEST,
  meta,
});

export const loadSessionSuccess = (session: AuthTokens, meta: MetaAction = {}): Actions.LoadSessionSuccessAction => ({
  type: types.LOAD_SESSION_SUCCESS,
  payload: session,
  meta,
});

export const loadSessionFailure = (error: Error | null, meta: MetaAction = {}): Actions.LoadSessionFailureAction => ({
  type: types.LOAD_SESSION_FAILURE,
  payload: error,
  error: true,
  meta,
});

export const forgotPassword = (username: string, meta: MetaAction = {}): Actions.ForgotPasswordRequestAction => ({
  type: types.FORGOT_PASSWORD_REQUEST,
  payload: username,
  meta,
});

export const forgotPasswordSuccess = (meta: MetaAction = {}): Actions.ForgotPasswordSuccessAction => ({
  type: types.FORGOT_PASSWORD_SUCCESS,
  meta,
});

export const forgotPasswordFailure = (error: Error, meta: MetaAction = {}): Actions.ForgotPasswordFailureAction => ({
  type: types.FORGOT_PASSWORD_FAILURE,
  payload: error,
  error: true,
  meta,
});

export const forgotPasswordSubmit = (
  payload: Actions.ForgotPasswordSubmitPayload,
  meta: MetaAction = {}
): Actions.ForgotPasswordSubmitRequestAction => ({
  type: types.FORGOT_PASSWORD_SUBMIT_REQUEST,
  payload,
  meta,
});

export const forgotPasswordSubmitSuccess = (meta: MetaAction = {}): Actions.ForgotPasswordSubmitSuccessAction => ({
  type: types.FORGOT_PASSWORD_SUBMIT_SUCCESS,
  meta,
});

export const forgotPasswordSubmitFailure = (error: Error, meta: MetaAction = {}): Actions.ForgotPasswordSubmitFailureAction => ({
  type: types.FORGOT_PASSWORD_SUBMIT_FAILURE,
  payload: error,
  error: true,
  meta,
});

export const setAuthStep = (step: LOGIN_STEPS, data?: Actions.StepData, meta: MetaAction = {}): Actions.SetAuthStepAction => ({
  type: types.SET_AUTH_STEP,
  payload: {
    step,
    data,
  },
  meta,
});

export const impersonateUserId = (userId: string, meta: MetaAction = {}): Actions.ImpersonateUserAction => ({
  type: types.IMPERSONATE_USER_ID,
  payload: {
    request: {
      method: 'PATCH',
      url: `${USERS_API_URL}/onBehalfUserId`,
      data: { onBehalfUserId: userId },
    },
  },
  meta,
});

export const stopImpersonateUser = (meta: MetaAction = {}): Actions.StopImpersonateUserAction => ({
  type: types.STOP_IMPERSONATE_USER_ID,
  payload: {
    request: {
      method: 'DELETE',
      url: `${USERS_API_URL}/onBehalfUserId`,
    },
  },
  meta,
});
